import { render } from "./QuestionsReviewPage .vue?vue&type=template&id=21fccb69&scoped=true"
import script from "./QuestionsReviewPage .vue?vue&type=script&lang=js"
export * from "./QuestionsReviewPage .vue?vue&type=script&lang=js"

import "./QuestionsReviewPage .vue?vue&type=style&index=0&id=21fccb69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fccb69"]])

export default __exports__